import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

export function Header() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/");
  };

  return (
    <header className="bg-white/98 backdrop-blur-sm border-b border-gray-100 shadow-sm">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-2 flex items-center justify-between">
        <Link to="/" className="flex items-center shrink-0">
          <img
            src="/images/logo.png"
            alt="Learning Platform"
            className="h-16 w-auto object-contain"
          />
        </Link>
        <nav className="flex items-center gap-6 sm:gap-8 text-sm tracking-wide">
          <Link
            to="/courses"
            className="text-gray-600 hover:text-ink-950 transition-colors font-medium"
          >
            Courses
          </Link>
          {user ? (
            <>
              <Link
                to="/dashboard"
                className="text-gray-600 hover:text-ink-950 transition-colors font-medium"
              >
                Dashboard
              </Link>
              <span className="text-gray-500 hidden sm:inline text-[13px] border-l border-gray-200 pl-6">
                {user.email}
              </span>
              <button
                type="button"
                onClick={handleLogout}
                className="text-gray-600 hover:text-ink-950 transition-colors font-medium"
              >
                Log out
              </button>
            </>
          ) : (
            <>
              <Link
                to="/login"
                className="text-gray-600 hover:text-ink-950 transition-colors font-medium"
              >
                Log in
              </Link>
              <Link
                to="/signup"
                className="bg-ink-950 text-white px-5 py-2.5 rounded-lg text-sm font-semibold tracking-wide hover:bg-ink-800 transition-colors duration-200 shadow-md"
              >
                Sign up
              </Link>
            </>
          )}
        </nav>
      </div>
    </header>
  );
}
